<template lang="pug">
  .data-table-wrapper(
    ref="data-table-wrapper"
    :style="tableWrapperStyle")
    v-table.data-table(:tableStyle="tableStyle")
      ul.data-table-header(slot="header",name="header",:style="headerStyle")
        v-tr
          //- VCheckBox(v-if="columns[columnName].checkBox")
          v-th(
            v-for="(columnName,index) in tableList"
            :key="columnName"
            :tableData="tableData"
            :columnName="columnName"
            :column="columns[columnName]"
            :columnStyle="columnName | columnStyle(columnsWidth, columns)"
            :sortDirection="columnName | sortDirection(orderBy)"
            :checkGroupValue="checkGroupValue"
            @changeOrderBy="changeOrderBy"
            @changeCheckAll="changeCheckAll")
          v-th(
            v-if="operationList && operationList.length>0"
            :column="{label:'操作'}"
            :columnStyle="operationWidth | operationStyle")
      slot(v-if="!isLoading && tableData.length > 0")
        v-tbody.data-table-content
          template(v-if="isTree")
            tree-table-record(
              v-for="(data,index) in tableData"
              :key="index"
              :recordIndex="[index]"
              :tableList="tableList"
              :mainColumn="mainColumn"
              :columns="columns"
              :columnsWidth="columnsWidth"
              :operationList="operationList"
              :operationWidth="operationWidth"
              :treeExpands="treeExpands"
              :style="recordStyle"
              :data="data"
              :hoverRecord="hoverRecord"
              :hoverBy="hoverBy"
              @changeTreeExpands="changeTreeExpands"
              @changeHoverRecord="changeHoverRecord")
          template(v-else)
            data-table-record(
              v-for="(data,index) in tableData"
              :key="data.id"
              :recordIndex="[index]"
              :tableList="tableList"
              :columns="columns"
              :columnsWidth="columnsWidth"
              :operationList="operationList"
              :operationWidth="operationWidth"
              :style="recordStyle"
              :data="data"
              :isCheckAll="isCheckAll"
              :hoverRecord="hoverRecord"
              :hoverBy="hoverBy"
              @handleCheckItem="handleCheckItem"
              @changeHoverRecord="changeHoverRecord")
            data-table-record(
              v-if="isCount"
              :recordIndex="[index]"
              :tableList="tableList"
              :columns="columns"
              :columnsWidth="columnsWidth"
              :operationList="operationList"
              :operationWidth="operationWidth"
              :style="recordStyle"
              :data="countData"
              :hoverRecord="hoverRecord"
              :hoverBy="hoverBy"
              @handleCheckItem="handleCheckItem"
              @changeHoverRecord="changeHoverRecord")
    slot(v-if="isLoading && hasLoading")
      .noData
        span.loading-wrapper
          span.loading
        | 加载中...
    slot(v-if="!isLoading && hasLoading && tableData.length===0")
      .noData 暂时没有数据
</template>

<script>
import IScroll from 'iscroll/build/iscroll-probe.js'

import { findIndex, sumBy } from 'lodash'

import DataTableRecord from './DataTableRecord'
import TreeTableRecord from './TreeTableRecord'
import VTable from '@/components/VTable'
import VThead from '@/components/VTable/VThead'
import VTbody from '@/components/VTable/VTbody'
import VTr from '@/components/VTable/VTr'
import VTh from '@/components/VTable/VTh'
import VTd from '@/components/VTable/VTd'
import VCheckBox from '@/components/VTable/VCheckBox'

export default {
  name: 'DataTableMain',
  components: {
    DataTableRecord,
    TreeTableRecord,
    VTable,
    VThead,
    VTbody,
    VTr,
    VTh,
    VTd,
    VCheckBox
  },
  props: {
    x: Number,
    y: Number,
    tableName: {
      type: String,
      default: ''
    },
    cid: {
      type: String,
      default: 'id'
    }, /* 页面对话框标题 */
    pid: {
      type: String,
      default: 'pid'
    }, /* 页面对话框标题 */
    columns: {
      type: Object,
      default: () => {
        return {}
      }
    },
    mainColumn: {
      type: String,
      default: ''
    },
    isCount: {
      type: Boolean,
      default: false
    },
    isScroll: {
      type: Boolean,
      default: false
    },
    hasLoading: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    operationList: Array,
    operationWidth: {
      type: Number,
      default: 200
    },
    clientHeight: {
      type: Number
    },
    tableWrapperWidth: {
      type: Number,
      default: 0
    },
    fullTableWidth: {
      type: Boolean,
      default: false
    },
    tableList: {
      type: Array,
      default: () => []
    },
    isCheckBox: {
      type: Boolean,
      default: false
    },
    isTree: {
      type: Boolean,
      default: false
    },
    orderBy: {
      type: Array,
      default: () => []
    },
    tableData: {
      type: Array,
      default: () => []
    },
    isExpand: Function,
    treeExpands: Array,
    hoverRecord: {
      type: String | Number
    },
    hoverBy: {
      type: String
    }
  },
  data () {
    return {
      isOutsideTbody: true,
      checkGroupValue: [],
      isCheckAll: false
    }
  },
  computed: {
    countData () {
      let countData = {}
      countData[this.tableList[0]] = '合计'
      this.tableList.map(item => {
        if (this.columns[item].isCount) {
          countData[item] = sumBy(this.tableData, item)
        }
      })
      return countData
    },
    tableWidth () {
      const operationWidth = this.operationList && this.operationList.length > 0 ? this.operationWidth : 0
      return this.columnWidth + operationWidth
    },
    columnWidth () {
      return this.tableList.reduce((acc, item) => {
        return acc + this.columns[item].width
      }, 0)
    }, // 所有列的宽度
    redundancyWidth () {
      const redundancyWidth = this.tableWrapperWidth - this.tableWidth - 2
      return redundancyWidth > 0 ? redundancyWidth : 0
    }, // 表格列冗余宽度
    recordStyle () {
      return {
        width: this.tableWidth + this.redundancyWidth + 'px'
      }
    },
    tableStyle () {
      let tableStyle = {}
      if (!this.isScroll) {
        if (this.x || this.y) {
          tableStyle['transform'] = `translate(${this.x || 0}px,${this.y || 0}px)`
        }
      }
      return {
        ...this.recordStyle,
        ...tableStyle
      }
    }, // 计算表格定位，用于同步悬浮层定位
    headerStyle () {
      let headerStyle = {}
      if (this.y) {
        headerStyle['transform'] = `translate(0px,${-this.y || 0}px)`
      }
      return headerStyle
    },
    tableWrapperStyle () {
      return {
        width: this.fullTableWidth ? '100%' : this.tableWrapperWidth + 'px'
      }
    },
    columnsWidth () {
      const { tableList, columns, redundancyWidth } = this
      const simple = Math.floor(redundancyWidth / tableList.length)
      const remainder = redundancyWidth - tableList.length * simple
      let columnsWidth = {}
      tableList.map((item, index) => {
        const normal = columns[item].width + simple
        columnsWidth[item] = index === (tableList.length - 1) ? normal + remainder : normal
      })
      return columnsWidth
    }
  },
  watch: {
    clientHeight () {
      if (this.tableScroll) {
        this.updatePosition()
      }
    },
    tableData (value) {
      if (this.checkGroupValue.length) {
        value.map(res => {
          const dataId = res.id
          const findIndex = this.checkGroupValue.findIndex(data => { return data === dataId })
          if (findIndex === -1) this.checkGroupValue.splice(findIndex, 1)
        })
      } else {
        this.isCheckAll = false
      }
    }
  },
  filters: {
    columnStyle (columnName, columnsWidth, columns) {
      return {
        width: columnsWidth[columnName] + 'px',
        ...columns[columnName].style
      }
    },
    operationStyle (width) {
      return {
        width: width + 'px'
      }
    },
    sortDirection (columnName, orderBy) {
      const sortIndex = findIndex(orderBy, ['name', columnName])
      if (sortIndex >= 0) {
        return orderBy[sortIndex].sort
      }
      return 'sort'
    }
  },
  updated () {
    if (this.isScroll) {
      if (this.tableScroll) {
        this.tableScroll.refresh()
      } else {
        this.initScroll()
      }
    }
  },
  methods: {
    initScroll () {
      this.tableScroll = new IScroll(this.$refs['data-table-wrapper'], {
        scrollX: true,
        scrollY: true,
        freeScroll: true,
        scrollbars: true,
        mouseWheel: true,
        interactiveScrollbars: true,
        probeType: 3,
        disablePointer: true,
        shrinkScrollbars: 'scale'
      })
      this.tableScroll.on('scroll', this.updatePosition)
    },
    updatePosition () {
      this.tableScroll.refresh()
      this.$emit('updatePosition', this.tableScroll.x, this.tableScroll.y)
    },
    changeOrderBy (data) {
      this.$emit('changeOrderBy', data)
    },
    changeTreeExpands (data) {
      this.$emit('changeTreeExpands', data)
    },
    changeHoverRecord (id) {
      this.$emit('changeHoverRecord', id)
    },
    handleCheckItem (value, checked) {
      // 多选
      let checkGroupValue = this.checkGroupValue
      const findIndex = checkGroupValue.findIndex(data => { return data === value })
      if (checked) {
        if (findIndex === -1) checkGroupValue.push(value)
      } else {
        if (findIndex !== -1) checkGroupValue.splice(findIndex, 1)
      }
      this.$emit('checkGroupValue', checkGroupValue)
    },
    changeCheckAll (value, checked) {
      // 全选
      this.isCheckAll = checked
      this.checkGroupValue = value
      this.$emit('checkGroupValue', this.checkGroupValue)
    }
  }
}
</script>

<style scoped lang="sass">
.loading
  height: 400px
.data-table-wrapper
  background: #fff
  overflow: hidden
.data-table
  display: flex
  flex-direction: column
  flex: 1
.data-table-header
  z-index: 1
.data-table-content
  display: flex
  flex: 1
  flex-direction: column
  box-shadow: 0px 0px 1px #999
.noData
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  text-align: center
  font-size: 18px
</style>



// WEBPACK FOOTER //
// Main.vue?53b03b23